import {
  FRAGMENT_CLAIMS,
  captureFragmentCredential,
  clearFragmentCredential,
  ownsRoute,
  replaceUrl,
  writeMirror,
} from '../lib/fragmentCredentials'

export const LINK_TOKEN_PARAM = 't'

const SECRET_PATH_SEGMENT = /\/[0-9a-f]{32,}(?=\/|$)/i

const DOC_ID_PATH_SEGMENT = /\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\/|$)/i

// Links already emailed and texted are chased for weeks, so the pre-fragment shapes stay readable.
const LEGACY_PATH_ROUTE = '/pay/'

const LEGACY_QUERY_ROUTE = '/bank-account/'

export const readLinkToken = (search) => {
  if (!search || typeof search !== 'string') return null

  try {
    const token = new URLSearchParams(search).get(LINK_TOKEN_PARAM)
    return token && token.trim() ? token.trim() : null
  } catch (error) {
    return null
  }
}

export const captureLinkToken = () => {
  if (typeof window === 'undefined') return null

  const { pathname, search } = window.location
  const path = pathname || ''

  const fromPath = path.startsWith(LEGACY_PATH_ROUTE) ? path.match(SECRET_PATH_SEGMENT) : null
  if (fromPath) {
    const token = fromPath[0].slice(1)
    const cleanPath = path.replace(SECRET_PATH_SEGMENT, '')
    writeMirror(FRAGMENT_CLAIMS.link, cleanPath, token)
    replaceUrl(cleanPath, search, '')
    return token
  }

  const fromQuery = path.startsWith(LEGACY_QUERY_ROUTE) ? readLinkToken(search) : null
  if (fromQuery) {
    writeMirror(FRAGMENT_CLAIMS.link, path, fromQuery)
    const params = new URLSearchParams(search)
    params.delete(LINK_TOKEN_PARAM)
    const remaining = params.toString()
    replaceUrl(path, remaining ? `?${remaining}` : '', '')
    return fromQuery
  }

  return captureFragmentCredential(FRAGMENT_CLAIMS.link)
}

let linkToken = captureLinkToken()

export const getLinkToken = () => linkToken

export const LINK_TOKEN_HEADER = 'X-Link-Token'

export const LINK_TOKEN_REFUSAL = 'linkTokenRequired'

export const setLinkToken = (token, pathname) => {
  if (!token) return
  linkToken = token
  writeMirror(FRAGMENT_CLAIMS.link, pathname, token)
}

export const linkTokenHeaders = () => (linkToken ? { [LINK_TOKEN_HEADER]: linkToken } : {})

export const linkTokenRefusalOf = (error) => {
  const first = error?.response?.data?.error?.errors?.[0]
  return error?.response?.status === 403 && first?.code === LINK_TOKEN_REFUSAL
    ? { code: LINK_TOKEN_REFUSAL, message: first.message }
    : null
}

export const clearLinkToken = () => {
  linkToken = null
  clearFragmentCredential(FRAGMENT_CLAIMS.link)
}

export const captureDocAccessId = () => {
  if (typeof window === 'undefined') return null

  const { pathname, search } = window.location
  const path = pathname || ''

  const fromPath = ownsRoute(FRAGMENT_CLAIMS.docAccess.routes, path)
    ? path.match(DOC_ID_PATH_SEGMENT)
    : null
  if (fromPath) {
    const id = fromPath[0].slice(1)
    const cleanPath = path.replace(DOC_ID_PATH_SEGMENT, '')
    writeMirror(FRAGMENT_CLAIMS.docAccess, cleanPath, id)
    replaceUrl(cleanPath, search, '')
    return id
  }

  return captureFragmentCredential(FRAGMENT_CLAIMS.docAccess)
}

let docAccessId = captureDocAccessId()

export const getDocAccessId = () => docAccessId
